import React, { useCallback, useState, useEffect } from 'react';
import { useT } from '@transifex/react';
import Grid from '@mui/material/Grid';
import { Dialog, Button, useRichTextEditor } from '@raisin/components-lib';
import ChartHeader from './ChartHeader';
import ChartBody from './ChartBody';
import messages from 'messages';
import * as S from './styles';
import {
  FIRST_INVESTMENT_MIN,
  FIRST_INVESTMENT_MIN_NEW,
  MONTHLY_PLAN_MIN,
  MONTHLY_PLAN_MIN_NEW,
} from './types';
import { useIsDWMMMEnabled } from '@raisin/investments-data/util/features';

const PrognoseChartIPP: React.FC = () => {
  const hasMoneyMarketQuery = useIsDWMMMEnabled();
  const hasMoneyMarket = hasMoneyMarketQuery.isSuccess && hasMoneyMarketQuery.data;
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [startAmount, setStartAmount] = useState<number>(FIRST_INVESTMENT_MIN);
  const [monthlyAmount, setMonthlyAmount] = useState<number>(MONTHLY_PLAN_MIN);
  const [portfolio, setPortfolio] = useState<number>(3);
  const [duration, setDuration] = useState(20);
  const t = useT();

  const prognoseChartParagraph = useRichTextEditor(t(messages.DWMPrognoseChartModalParagraph), {
    a: () => <a href="https://www.weltsparen.de/investieren/risikohinweise"></a>,
  });

  const handleOnToggleDialog = useCallback(() => setIsDialogOpen((prevStatus) => !prevStatus), []);

  useEffect(() => {
    setStartAmount(hasMoneyMarket ? FIRST_INVESTMENT_MIN_NEW : FIRST_INVESTMENT_MIN);
    setMonthlyAmount(hasMoneyMarket ? MONTHLY_PLAN_MIN_NEW : MONTHLY_PLAN_MIN);
  }, [hasMoneyMarket]);

  return (
    <S.Container maxWidth>
      <Dialog
        onClose={handleOnToggleDialog}
        open={isDialogOpen}
        title={t(messages.DWMPrognoseChartModalHeading)}
        content={prognoseChartParagraph}
        actions={
          <Button mode="secondary" onClick={handleOnToggleDialog}>
            {t(messages.DWMPrognoseChartModalCta)}
          </Button>
        }
      />
      <S.Content>
        <Grid item xs={12} mt={{ xs: 2, md: 0 }}>
          <ChartHeader
            startAmount={startAmount}
            monthlyAmount={monthlyAmount}
            portfolio={portfolio}
            duration={duration}
            changeStartAmount={setStartAmount}
            changeMonthlyAmount={setMonthlyAmount}
            changePortfolio={setPortfolio}
            changeDuration={setDuration}
            hasMoneyMarket={hasMoneyMarket}
          />
        </Grid>
        <Grid item xs={12} mt={5}>
          <ChartBody
            startAmount={startAmount}
            monthlyAmount={monthlyAmount}
            portfolio={portfolio}
            duration={duration}
            openDetailsModal={handleOnToggleDialog}
            hasMoneyMarket={hasMoneyMarket}
          />
        </Grid>
      </S.Content>
    </S.Container>
  );
};

export default PrognoseChartIPP;
